import axios from 'axios';

export const formatDispatcherSaveError = (error: unknown): string => {
  if (axios.isAxiosError(error) && error.response?.data) {
    const data = error.response.data as { message?: string; error?: string };
    if (typeof data.message === 'string' && data.message.length > 0) {
      return data.message;
    }
    if (typeof data.error === 'string' && data.error.length > 0) {
      if (error.response.status === 401) {
        return 'Your session expired. Please sign out, sign back in, and try again.';
      }
      return data.error;
    }
  }

  if (error instanceof Error && error.message.length > 0) {
    return error.message;
  }

  return 'An unknown error occurred. Please contact technical support.';
};
